import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { CreateGarantieProduit } from "../../core/model/garantie-produit/create-garantie-produit";
import { GarantieProduitService } from "../../core/service/garantie-produit.service";

@Component({
  selector: "app-add-garantie-produit",
  templateUrl: "./add-garantie-produit.component.html",
  styleUrls: ["./add-garantie-produit.component.scss"],
})
export class AddGarantieProduitComponent implements OnInit {
  erreur: String = "";
  @Input() produitId;

  createGarantieProduit: CreateGarantieProduit = new CreateGarantieProduit();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _garantieProduitService: GarantieProduitService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.createGarantieProduit.produitId = this.produitId;
    console.log(this.createGarantieProduit);
  }

  save(): void {
    this.pressButton = true;
    this._garantieProduitService
      .add(this.createGarantieProduit)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          this.erreur = error.error.message;
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
